import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from "react";

interface RagNavRefreshContextValue {
  refreshKey: number;
  refreshRagNav: () => void;
}

const RagNavRefreshContext = createContext<RagNavRefreshContextValue | null>(null);

export function RagNavRefreshProvider({ children }: { children: ReactNode }) {
  const [refreshKey, setRefreshKey] = useState(0);

  const refreshRagNav = useCallback(() => {
    setRefreshKey((key) => key + 1);
  }, []);

  const value = useMemo(
    () => ({ refreshKey, refreshRagNav }),
    [refreshKey, refreshRagNav]
  );

  return (
    <RagNavRefreshContext.Provider value={value}>{children}</RagNavRefreshContext.Provider>
  );
}

export function useRagNavRefreshKey(): number {
  const context = useContext(RagNavRefreshContext);
  if (!context) {
    throw new Error("useRagNavRefreshKey must be used within RagNavRefreshProvider");
  }
  return context.refreshKey;
}

export function useRefreshRagNav(): () => void {
  const context = useContext(RagNavRefreshContext);
  if (!context) {
    throw new Error("useRefreshRagNav must be used within RagNavRefreshProvider");
  }
  return context.refreshRagNav;
}
